export const tags = [
  "jnct-plugin-host",
  "jnct-plugin-configurator",
  "jnct-plugin-grading",
] as const;
